const STATUS_LABELS = { NOT_STARTED: "لم يبدأ", IN_PROGRESS: "قيد التنفيذ", SUBMITTED: "تم التسليم" };

const BRAND = "FF4F46E5"; // لون الهيدر، غيّره براحتك
const BORDER = { style: "thin", color: { argb: "FFD9DCE3" } };
const ALL_BORDERS = { top: BORDER, left: BORDER, bottom: BORDER, right: BORDER };

export async function exportQuizResultsToExcel(quiz, data) {
  const mod = await import("exceljs/dist/exceljs.min.js"); // تحميل كسول عشان ما يتقلش الـ bundle
  const ExcelJS = mod.default || mod;

  const wb = new ExcelJS.Workbook();
  const sheetName = (quiz.title || "النتائج").replace(/[\\/?*[\]:]/g, " ").slice(0, 31);
  const ws = wb.addWorksheet(sheetName, {
    views: [{ rightToLeft: true, state: "frozen", ySplit: 4 }],
    pageSetup: { orientation: "portrait", fitToPage: true, fitToWidth: 1, fitToHeight: 0 },
  });

  ws.columns = [
    { key: "n", width: 6 },
    { key: "name", width: 34 },
    { key: "status", width: 14 },
    { key: "score", width: 12 },
    { key: "total", width: 12 },
    { key: "pct", width: 12 },
    { key: "attempts", width: 16 },
  ];
  const LAST_COL = "G";

  // ── العنوان ──
  ws.mergeCells(`A1:${LAST_COL}1`);
  const title = ws.getCell("A1");
  title.value = `نتائج اختبار: ${quiz.title}`;
  title.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
  title.fill = { type: "pattern", pattern: "solid", fgColor: { argb: BRAND } };
  title.alignment = { horizontal: "center", vertical: "middle" };
  ws.getRow(1).height = 32;

  // ── الملخص ──
  ws.mergeCells(`A2:${LAST_COL}2`);
  const summary = ws.getCell("A2");
  summary.value =
    `الطلاب: ${data.assigned}   |   سلّموا: ${data.submitted}   |   قيد التنفيذ: ${data.in_progress}` +
    `   |   لم يبدؤوا: ${data.not_started}   |   متوسط أعلى الدرجات: ${data.average_percentage}%`;
  summary.font = { size: 11, color: { argb: "FF374151" } };
  summary.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFEEF2FF" } };
  summary.alignment = { horizontal: "center", vertical: "middle" };
  ws.getRow(2).height = 24;

  ws.getRow(3).height = 8; // فاصل

  // ── رأس الجدول ──
  const header = ws.getRow(4);
  header.values = ["#", "اسم الطالب", "الحالة", "الدرجة الأعلى", "من", "النسبة", "المحاولات المستخدمة"];
  header.height = 26;
  header.eachCell((c) => {
    c.font = { bold: true, color: { argb: "FFFFFFFF" } };
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: BRAND } };
    c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    c.border = ALL_BORDERS;
  });

  // ── الصفوف ──
  (data.students || []).forEach((s, i) => {
    const submitted = s.status === "SUBMITTED";
    const row = ws.addRow({
      n: i + 1,
      name: s.full_name,
      status: STATUS_LABELS[s.status] || s.status,
      score: submitted ? Number(s.score) : "-",
      total: submitted ? Number(s.total_points) : "-",
      pct: submitted ? Number(s.percentage) / 100 : "-",
      attempts: `${s.attempts_used}/${data.max_attempts}`,
    });
    row.height = 22;
    row.eachCell((c, col) => {
      c.border = ALL_BORDERS;
      c.alignment = { horizontal: col === 2 ? "right" : "center", vertical: "middle" };
      if (i % 2 === 1) c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF8FAFC" } };
    });
    row.getCell("pct").numFmt = "0.0%";
    row.getCell("score").font = { bold: true };

    // تلوين النسبة
    if (submitted) {
      const p = Number(s.percentage);
      const color = p >= 75 ? "FF15803D" : p >= 50 ? "FFB45309" : "FFB91C1C";
      row.getCell("pct").font = { bold: true, color: { argb: color } };
    }
  });

  // فلتر على الهيدر
  ws.autoFilter = { from: "A4", to: `${LAST_COL}4` };

  // ── تنزيل الملف ──
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(quiz.title || "quiz").replace(/[\\/:*?"<>|]/g, "_")}_results.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}